import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export interface LegendItem {
  key: string;
  label: string;
  visible: boolean;
  symbolStyle?: string;
  symbolClass?: string;
}
interface IArgs {
  items: LegendItem[];
  enableEditing?: boolean;
  onToggleItem?: (item: LegendItem) => void;
}

export default class BvChartLegend extends Component<IArgs> {
  @tracked editing = false;

  get enableEditing() {
    return this.args.enableEditing ?? true;
  }

  get visibleItems() {
    const { items } = this.args;
    if (!items) return [];
    return items.filter((i) => this.editing || i.visible);
  }

  @action
  toggleEditing() {
    this.editing = !this.editing;
  }
}
